import { action, observable, makeObservable } from 'mobx';
import { SignUpMainSteps } from './stepsStructure/SignupMainSteps';
import { GoogleTagManagerState } from 'src/domains/layouts/state/googleState/GoogleTagManagerState';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { AccountState } from 'src/domains/players/shared/Types';
import { CustomKeyboardState } from 'src/domains/players/state/CustomKeyboardState';
import { SignupPopupState } from 'src/domains/players/state/SignupPopupState';
import { Common } from 'src/domains/common/Common';
import { ModalState } from 'src/domains/layouts/webview/components/modals/Modal.state';
import { AutoWeakMap } from 'src_common/common/mobx-utils/AutoWeakMap';
export class SignUpState {
    @observable public isLoading: boolean = false;

    public currentView: SignUpMainSteps;

    private customKeyboard: CustomKeyboardState;
    private signupPopupState: SignupPopupState;
    private modalState: ModalState;

    public constructor(private readonly common: Common) {
        makeObservable(this);
        this.customKeyboard = CustomKeyboardState.get(common);
        this.signupPopupState = SignupPopupState.get(common);
        this.modalState = ModalState.get(common);

        this.currentView = new SignUpMainSteps(
            {
                customKeyboard: this.customKeyboard,
                signupPopupState: this.signupPopupState,
                modalState: this.modalState,
                common: common,
            },
            this.setLoading
        );
    }

    static get = AutoWeakMap.create((common: Common) => new SignUpState(common));

    @action public rebuildState = (): void => {
        const googleTagManager = GoogleTagManagerState.get(this.common);
        this.currentView = new SignUpMainSteps(
            {
                customKeyboard: this.customKeyboard,
                signupPopupState: this.signupPopupState,
                modalState: this.modalState,
                common: this.common,
            },
            this.setLoading
        );
        googleTagManager.renderNewUuid();
    };

    @action public setLoading = (isLoading: boolean): void => {
        this.isLoading = isLoading;
    };

    @action public toggleAside = async (): Promise<void> => {
        StarRouter.get(this.common).closeAccount();
        const accountState = AccountState.get(this.common);
        await this.modalState.closeAll();

        if (this.isLoading) {
            await accountState.handleLogout();
        }
    };
}
